import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/event_title.png'
import _imports_1 from '@/assets/horse_left_pc.png'
import _imports_2 from '@/assets/horse_right_pc.png'


const _hoisted_1 = { class: "event_main" }
const _hoisted_2 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"header\"><div class=\"main_hader_wrap\"><div class=\"main_hader\"><i></i><i></i><i></i><i></i><h1> 2026 &lt;액션시민&gt; <span>반성매매 온라인캠페인</span></h1></div></div><div class=\"main_title\"><img src=\"" + _imports_0 + "\" alt=\"\"><h2>성매매 CUT 시민 ACTION</h2></div></div><div class=\"main_comment\"><p>성매매 없는 사회를 위해 나아가는</p><p>&lt;액션시민&gt;참여자들이 목소리를 모으고 있습니다.</p><p> 공감되는 메시지를 선택하고, <span>당신의 한마디도 남겨주세요!</span></p></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("p", null, [
          _createElementVNode("label", null, "참여기간"),
          _createTextVNode(" 7월 14일(화) ~ 7월 27일(월) ")
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, "당첨상품"),
          _createElementVNode("span", null, [
            _createTextVNode(" 편의점 상품권 3,000원 "),
            _createElementVNode("span", null, "(100명 추첨)")
          ])
        ]),
        _createElementVNode("p", null, [
          _createElementVNode("label", null, "당첨발표"),
          _createElementVNode("span", null, [
            _createTextVNode(" 2026년 8월 3일(월) "),
            _createElementVNode("span", { class: "info" }, "*당첨자 홈페이지 게시 및 개별 문자 발송")
          ])
        ])
      ], -1)),
      _createElementVNode("button", {
        class: "start_btn",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emit('start')))
      }, "시작하기"),
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        class: "horse_left",
        src: _imports_1,
        alt: ""
      }, null, -1)),
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        class: "horse_right",
        src: _imports_2,
        alt: ""
      }, null, -1))
    ])
  ]))
}